export const validBody = (currentUserData: any, newUserData: any) => {
    let diff = (
        Object.keys(newUserData) as Array<keyof typeof newUserData>
    ).reduce((diff, key) => {
        if (currentUserData[key] === newUserData[key]) return diff;
        if (newUserData[key] !== "") {
            return {
                ...diff,
                [key]: newUserData[key],
            };
        } else if (newUserData[key] === "" && currentUserData[key] !== null) {
            return {
                ...diff,
                [key]: null,
            };
        } else {
            const deleteList: any = diff;
            delete deleteList[key];
            diff = deleteList;
            return diff;
        }
    }, {});
    return diff;
};

export const enableButtonUser = (userData: any) => {
    let value = (Object.keys(userData) as Array<keyof typeof userData>).length;
    if (value !== 0) {
        return true;
    } else {
        return false;
    }
};
